"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M7 1a1 1 0 00-1-1H1a1 1 0 00-1 1v5a1 1 0 001 1h5a1 1 0 001-1V1zM7 10a1 1 0 00-1-1H1a1 1 0 00-1 1v5a1 1 0 001 1h5a1 1 0 001-1v-5zM16 1a1 1 0 00-1-1h-5a1 1 0 00-1 1v14a1 1 0 001 1h5a1 1 0 001-1V1z"];
//# sourceMappingURL=layout-left-column-two-tiles.js.map